<template>
  <div>
    <b-tabs content-class="mt-3" class="custom-tabs mt-3">
      <!-- Tab de Perfil -->
      <b-tab active>
        <template #title>
          <b-icon-person-fill class="mr-2"></b-icon-person-fill>
          {{ $t("reusable.userCard.profileTab") }}
        </template>
        <template v-if="user.is_student">
          <StudentCard :User="user"></StudentCard>
        </template>
        <template v-else>
          <UserCard :User="user"></UserCard>
        </template>
      </b-tab>

      <!-- Tab de Actividad (solo para directores de carrera y superiores) -->
      <b-tab
        v-if="
          user &&
          ([
            'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
            'DIRECTIVOS ACADÉMICOS (CAMPUS)',
            'DIRECTIVOS FACULTAD O ESCUELA',
            'DIRECTORES DE CARRERA',
            'DIRECTORES DE CARRERA (CAMPUS)',
            'ADMINISTRATIVOS INSTRUCCIONALES',
          ].some((group) => user.group_names.includes(group)) ||
            user.is_superuser)
        "
        lazy
      >
        <template #title>
          <b-icon-clock-history class="mr-2"></b-icon-clock-history>
          {{ $t("reusable.userCard.activityTab") }}
        </template>
        <UserLogsView></UserLogsView>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";

export default {
  name: "UseCardView",
  components: {
    StudentCard: () => import("@/components/cideu/UseCard/StudentCard"),
    UserCard: () => import("@/components/reusable/UserCard"),
    UserLogsView: () => import("@/components/reusable/UserLogsView"),
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
  },
  methods: {},
  created() {
    this.$hasPermissions();
  },
};
</script>

<style scoped>
.custom-tabs >>> .nav-tabs {
  border-bottom: 2px solid var(--kl-border);
}

.custom-tabs >>> .nav-link {
  font-family: var(--kl-font-family);
  font-size: var(--kl-fs-body);
  color: var(--kl-text-muted);
  border: none;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
}

.custom-tabs >>> .nav-link:hover {
  color: var(--kl-color-accent);
  border-bottom-color: var(--kl-color-accent-border);
}

.custom-tabs >>> .nav-link.active {
  color: var(--kl-color-accent);
  background-color: transparent;
  border-bottom-color: var(--kl-color-accent);
  font-weight: var(--kl-fw-semibold);
}
</style>
